// extracted by mini-css-extract-plugin
export default {"modal-overlay":"Modal_modal-overlay__FM0JJ","show":"Modal_show__isxza","modal":"Modal_modal__5FZ5s","modal-close":"Modal_modal-close__VGmwq","modal-title":"Modal_modal-title__EiMbj"};